<template>
    <div class="toasts">
        <Toast
            v-for="toast in toasts"
            :key="toast.id"
            :toast="toast"
            :body-text="toast.bodyText"
            :button-text="toast.buttonText"
            :type="toast.type"
            class="toast"
            @click="toast.buttonClick"
            @removeToast="removeToast"
        />
    </div>
</template>

<script>
import Vue from 'vue'
import Toast from '@/components/toast/Toast'

export default {
    name: 'ToastManager',
    components: { Toast },
    data() {
        return {
            toasts: [],
        }
    },
    mounted() {
        /**
         * this function spawns a new toast
         * @param type
         * @param bodyText
         * @param buttonText
         * @param buttonClick
         */
        Vue.prototype.$pm['createToast'] = (type, bodyText, buttonText = null, buttonClick = null) => {
            let toast = {
                id: Math.floor(Math.random() * 1000),
                type,
                bodyText,
                buttonText,
                buttonClick: () => {
                    this.toasts.splice(this.toasts.indexOf(toast), 1)
                    if (buttonClick instanceof Function) buttonClick()
                },
            }
            this.toasts.push(toast)
            setTimeout(() => {
                this.toasts.splice(this.toasts.indexOf(toast), 1)
            }, 50000)
        }

        Vue.prototype.$pm['clearAllToasts'] = () => {
            this.toasts = []
        }
    },
    methods: {
        removeToast(toast) {
            const i = this.toasts.find((a) => a.id === toast.id)
            this.toasts.splice(i, 1)
        },
    },
}
</script>

<style lang="sass" scoped>
.toasts
    position: fixed
    z-index: 50
    bottom: $m
    left: 50%
    transform: translateX(-50%)

    display: flex
    flex-direction: column

    .toast
        margin-bottom: $xs
        box-shadow: 0 15px 35px rgba(50, 50, 93, 0.1), 0 5px 15px rgba(0, 0, 0, 0.07)
</style>
